import React from 'react';
/**
 * MoneyAssemblerRenderer — Wrapper adapting MoneyAssembler to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 *
 * The inner <MoneyAssembler> already owns the rising-edge submit (it fires
 * onComplete(JSON.stringify(tokens)) once when shouldValidate flips true), so
 * we forward it straight to onAnswer. A previous wrapper-level second edge
 * detector read a buffered answer one tick too early and submitted an empty
 * payload.
 */
import { QuestionRendererProps } from './types';
import { MoneyAssembler } from '../MoneyAssembler';
export function MoneyAssemblerRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  return <MoneyAssembler question={question} onComplete={onAnswer} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-11761" data-mp="3gtlwayhr2yge" />;
}